import React from 'react';

import FaqPage from '../components/FaqPage';

const FAQ = () => (
  <FaqPage
    lang="zh"
    title="常见问题 | 全栈公开课"
    seoDescription="Frequently asked questions"
  />
);

export default FAQ;
